import { getCurrentUser } from '@/lib/auth-client'
import { ApiError, clearForbiddenCache } from '@/lib/axios-client'
import { queryKeys } from '@/lib/query-keys'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { isAuthTransitionInFlight } from '@/helpers/auth'

export const authKeys = {
  all: ['auth'] as const,
  user: () => [...authKeys.all, 'user'] as const,
} as const

const AUTH_STALE_TIME_MS = 30_000

export const useAuthQuery = () => {
  return useQuery({
    queryKey: queryKeys.auth.user,
    queryFn: getCurrentUser,
    enabled: !isAuthTransitionInFlight(),
    retry: (failureCount, error) => {
      const status = error instanceof ApiError ? error.status : undefined
      if (status === 401) return false
      return failureCount < 2
    },
    staleTime: AUTH_STALE_TIME_MS,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
  })
}

export const useRefreshAuth = () => {
  const queryClient = useQueryClient()
  return useCallback(() => {
    clearForbiddenCache()
    return queryClient.invalidateQueries({ queryKey: queryKeys.auth.user })
  }, [queryClient])
}
